import { z } from 'zod';
import { LocationType } from '../../constants/location-type.js';
import { optionalUuidString, requiredEnumIdString } from '../zod-helpers/index.js';
import { LOCATION_CONSTRAINTS } from './constraints.js';
export const locationNameSchema = z
    .string()
    .trim()
    .min(1, `${LOCATION_CONSTRAINTS.name.label} is required.`)
    .max(LOCATION_CONSTRAINTS.name.maxLength, `${LOCATION_CONSTRAINTS.name.label} must be ${LOCATION_CONSTRAINTS.name.maxLength} characters or fewer.`);
export const locationDescriptionSchema = z
    .string()
    .trim()
    .max(LOCATION_CONSTRAINTS.description.maxLength, `${LOCATION_CONSTRAINTS.description.label} must be ${LOCATION_CONSTRAINTS.description.maxLength} characters or fewer.`);
/**
 * Shared base shape for both create and edit forms — locationGroupId and activeFlag are only
 * collected on create (a location's group can't change after create, and it's always active on
 * create), so they're optional here and enforced by locationCreateSchema's superRefine instead.
 * Keeping one base schema (rather than separate create/edit shapes) lets both forms share a
 * single form-values type and the same field-group components, matching the vendor module.
 */
export const locationFormFieldsSchema = z.object({
    name: z.string(),
    description: z.string(),
    locationGroupId: optionalUuidString(`Invalid ${LOCATION_CONSTRAINTS.locationGroupId.label.toLowerCase()} selection.`).optional(),
    typeId: requiredEnumIdString(LocationType, 'Location type is required.', 'Invalid location type selection.'),
    activeFlag: z.boolean().optional(),
    pickable: z.boolean(),
    receivable: z.boolean(),
    countedAsAvailable: z.boolean(),
});
function withNameAndDescriptionRefinements(values, context) {
    const nameResult = locationNameSchema.safeParse(values.name);
    if (!nameResult.success) {
        context.addIssue({
            code: 'custom',
            message: nameResult.error.issues[0].message,
            path: ['name'],
        });
    }
    if (values.description !== '') {
        const descriptionResult = locationDescriptionSchema.safeParse(values.description);
        if (!descriptionResult.success) {
            context.addIssue({
                code: 'custom',
                message: descriptionResult.error.issues[0].message,
                path: ['description'],
            });
        }
    }
}
export const locationEditSchema = locationFormFieldsSchema.superRefine(withNameAndDescriptionRefinements);
export { withNameAndDescriptionRefinements };
//# sourceMappingURL=update-form.js.map